/* global axios */
import ApiClient from '../ApiClient';

class CarListingsAPI extends ApiClient {
  constructor() {
    super('car_listings', { accountScoped: true, wgpt: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  publish(listingId) {
    return axios.post(`${this.url}/${listingId}/publish`);
  }

  unpublish(listingId, status) {
    return axios.post(`${this.url}/${listingId}/unpublish`, { status });
  }

  attachPhoto(listingId, slot, data) {
    return axios.post(`${this.url}/${listingId}/photos/${slot}`, data);
  }

  removePhoto(listingId, slot) {
    return axios.delete(`${this.url}/${listingId}/photos/${slot}`);
  }

  regeneratePhoto(listingId, slot) {
    return axios.post(`${this.url}/${listingId}/photos/${slot}/regenerate`);
  }

  attachVideo(listingId, data) {
    return axios.post(`${this.url}/${listingId}/video`, data);
  }

  removeVideo(listingId) {
    return axios.delete(`${this.url}/${listingId}/video`);
  }

  generateSocialPostCaption(listingId, payload) {
    return axios.post(`${this.url}/${listingId}/social_posts/caption`, payload);
  }

  publishSocialPosts(listingId, payload) {
    return axios.post(`${this.url}/${listingId}/social_posts`, payload);
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(payload) {
    return axios.patch(`${this.url}/settings`, payload);
  }

  directUploadUrl(listingId) {
    return `${this.url}/${listingId}/direct_uploads`;
  }
}

export default new CarListingsAPI();
